import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import L from "leaflet";
import { Map, TileLayer, ZoomControl, Marker } from "react-leaflet";
import "leaflet-side-by-side";
import ShareControl from "components/map/share-control";
import InfoControl from "components/map/info-control";
import BasemapControl from "components/map/basemap-control";
import { basemaps, labels } from "./constants";


import "./style.css";

class MapComponent extends PureComponent {
  componentDidMount() {
    this.map = this.mapElement.leafletElement;
  }

  addOriginalLayer(originalLayer) {
    const { comparingTilesUrl } = this.props;

    if (comparingTilesUrl) {
      this.initSideBySide();
      this.sideBySideControl.setLeftLayers(originalLayer);
    }
  }

  addComparingLayer(comparingLayer) {
    const { comparingTilesUrl } = this.props;

    if (comparingTilesUrl) {
      this.initSideBySide();
      this.sideBySideControl.setRightLayers(comparingLayer);
    }
  }

  /**
   * Init side by side plugin
   */
  initSideBySide() {
    if (!this.sideBySideControl) this.sideBySideControl = L.control.sideBySide().addTo(this.map);
  }

  render() {
    const {
      mapOptions,
      bounds,
      tilesUrl,
      comparingTilesUrl,
      onClickShare,
      onClickInfo,
      onChangeBasemap,
      onChangeLabels,
      onViewportChange,
      basemap: basemapId,
      labels: labelsId,
      language: languageId,
      demo,
      latLng
    } = this.props;

    const options = { ...MapComponent.defaultMapOptions, ...mapOptions };

    const iconMarker = new L.Icon({
      iconUrl: require('../../images/icons/marker_airqast.svg'),
      iconAnchor: [5, 55],
      iconSize: [35, 55],
    })

    options.bounds = bounds;

    return (
      <div className="c-map">
        <Map
          {...options}
          ref={(element) => {
            this.mapElement = element;
          }}
          bounds={bounds}
          onViewportChanged={onViewportChange}
          className="c-leaflet-map"
        >
          <ZoomControl
            position="topleft"
          />

          <div
            className="leaflet-control-container"
            id="leaflet-control-basemap-container"
          >
            <ShareControl
              position="topleft"
              onClickShare={() => onClickShare()}
            />
            {demo === 'emissions' &&
              <InfoControl
                position="topleft"
                onClickInfo={() => onClickInfo()}
              />
            }
            <BasemapControl
              basemap={basemapId}
              label={labelsId}
              language={languageId}
              setBasemap={onChangeBasemap}
              setLabel={onChangeLabels}
              position="topleft"
            />
          </div>


          {basemapId && (
            <TileLayer
              attribution={basemaps[basemapId].attribution}
              url={basemaps[basemapId].url}
              zIndex={1}
              onAdd={() => onChangeBasemap(basemapId)}
            />
          )
          }
          {demo === 'emissions' && latLng && (
            <Marker
              className="marker"
              position={latLng}
              icon={iconMarker}
            />

          )}
          {labelsId && languageId && (
            <TileLayer
              attribution={labels[labelsId][languageId].attribution}
              url={labels[labelsId][languageId].url}
              zIndex={10}
              onAdd={() => onChangeLabels(labelsId)}
            />
          )
          }
          {tilesUrl && (
            <TileLayer
              url={tilesUrl}
              opacity={0.5}
              zIndex={5}
              onAdd={e => this.addOriginalLayer(e.target)}
            />
          )
          }
          {comparingTilesUrl && (
            <TileLayer
              url={comparingTilesUrl}
              opacity={0.5}
              zIndex={5}
              onAdd={e => this.addComparingLayer(e.target)}
            />
          )
          }
        </Map>
      </div>
    );
  }
}

MapComponent.defaultMapOptions = {
  center: [40, 115],
  zoom: 5,
  zoomControl: false,
  scrollWheelZoom: false,
};

MapComponent.propTypes = {
  mapOptions: PropTypes.object,
  bounds: PropTypes.array,
  tilesUrl: PropTypes.string,
  comparingTilesUrl: PropTypes.string,
  // ID of the selected basemap
  basemap: PropTypes.string.isRequired,
  // ID of the selected labels layer
  labels: PropTypes.string.isRequired,
  // ID of the selected language for labels layer
  language: PropTypes.string.isRequired,
  onClickShare: PropTypes.func,
  onClickInfo: PropTypes.func,
  onChangeBasemap: PropTypes.func,
  onChangeLabels: PropTypes.func,
  onViewportChange: PropTypes.func,
  viewport: PropTypes.object,
  demo: PropTypes.string,
  latLng: PropTypes.array
};

MapComponent.defaultProps = {
  mapOptions: {},
  viewport: {},
  bounds: null,
  tilesUrl: null,
  comparingTilesUrl: null,
  demo: null,
  latLng: [],
  onClickShare: () => {
  },
  onClickInfo: () => {
  },
  onChangeBasemap: () => {
  },
  onChangeLabels: () => {
  },
  onViewportChange: () => {
  },
};

export default MapComponent;



// WEBPACK FOOTER //
// ./src/components/map/component.js